import { lookup } from "mime-types";

import { DownloadResponse } from "./types";
import getDropbox from "../../../../api/dropbox";

const dropbox = getDropbox();

export const downloadFile = (fileId: string) => (
  (dropbox.filesDownload({ path: fileId }) as Promise<DownloadResponse>)
    .then(({ name, client_modified, fileBlob }) => {
      const options: FilePropertyBag = {
        type: lookup(name) || undefined,
        lastModified: new Date(client_modified).getTime(),
      };

      return new File([fileBlob], name, options);
    })
);
